import { render, staticRenderFns } from "./DashboardTaskListItem.vue?vue&type=template&id=50df31c6&scoped=true&"
import script from "./DashboardTaskListItem.vue?vue&type=script&lang=js&"
export * from "./DashboardTaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTaskListItem.vue?vue&type=style&index=0&id=50df31c6&scoped=true&lang=css&"
import style1 from "./DashboardTaskListItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df31c6",
  null
  
)

export default component.exports